import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-b border-ink/10 bg-white py-10 sm:py-14" data-id="element-164" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-165" data-mp="1t8niy08x17ou">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-ink/10' : ''}`} data-id="element-166" data-mp="1jd3pdkhtql39" data-mpi={index}>
            <dt className="sr-only" data-id="element-167" data-mp="19mr7k01e960t">{stat.label}</dt>
            <dd data-id="element-168" data-mp="19ky0ijmvcjsa">
              <span className="block font-display text-4xl font-extrabold text-ink sm:text-5xl" data-id="element-169" data-mp="19keh0yhklnc5">
                {stat.value}
              </span>
              <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-ink/50 sm:text-xs" data-id="element-170" data-mp="10mlyzmkgs1l2">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}